var firstDay = new Date(new Date().getFullYear(), 0, 1);

const initialState = {    
    fromDate: firstDay,
    toDate: new Date(),    
    numberOfTransactions: 0,
    numberOfTransactionsByCountry: [],
    numberOfTransactionsByPaymentType: [],
    amountTotal: 0,
    amountByCountry: []
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {

    case "MAP_DASHBOARD_FROM_DATE":
        return{
            ...state,
            fromDate: action.data
        }

    case "MAP_DASHBOARD_TO_DATE":
        return{
            ...state,
            toDate: action.data
        }

    case "MAP_DASHBOARD_NUMBER_OF_TRANSACTIONS":
        return{
            ...state,
            numberOfTransactions: action.data
        }

    case "MAP_DASHBOARD_NUMBER_OF_TRANSACTIONS_BY_COUNTRY":
        return{
            ...state,
            numberOfTransactionsByCountry: action.data
        }
    case "MAP_DASHBOARD_NUMBER_OF_TRANSACTIONS_BY_PAYMENT_TYPE":
        return{
            ...state,
            numberOfTransactionsByPaymentType: action.data
        }

    case "MAP_DASHBOARD_AMOUNT":
        return{
            ...state,
            amountTotal: action.data
        }

    case "MAP_DASHBOARD_AMOUNT_BY_COUNTRY":
        return{
            ...state,
            amountByCountry: action.data
        }
        
    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
